import { ImageGallery } from '../../components/ImageGallery';
import { PageSection } from '../../components/Section';
import { SkeletonCard, SkeletonRow } from '../../components/SkeletonCard';
import { ProductContentPanel } from '../../composites/ProductContentPanel';
import { SplitLayout } from '../../composites/SplitLayout';
import type { ProductDetailTemplateProps } from './ProductDetailTemplate.types';

export function ProductDetailTemplate({
  images = [],
  onBack,
  previousImageLabel,
  nextImageLabel,
  goToImageLabel,
  viewAllLabel,
  recommendations,
  ...contentProps
}: ProductDetailTemplateProps) {
  const showRecommendations = contentProps.isLoading || !!recommendations;

  return (
    <>
      <SplitLayout
        left={
          <ImageGallery
            images={images}
            onBack={onBack}
            sticky
            prevLabel={previousImageLabel}
            nextLabel={nextImageLabel}
            goToImageLabel={goToImageLabel}
            backLabel={viewAllLabel}
          />
        }
        right={<ProductContentPanel {...contentProps} />}
      />

      {showRecommendations && (
        <PageSection $fullWidth>
          {contentProps.isLoading ? (
            <SkeletonRow>
              {Array.from({ length: 4 }).map((_, i) => (
                <SkeletonCard key={i} variant="grid" />
              ))}
            </SkeletonRow>
          ) : (
            recommendations
          )}
        </PageSection>
      )}
    </>
  );
}
